import { RouterButton } from "@/components/base/RouterButton";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type NotFoundProps = {
	readonly data?: unknown;
	readonly children?: ReactNode;
};

export function NotFound({ children }: NotFoundProps) {
	const { t } = useTranslation();

	return (
		<div className="flex items-center justify-center h-full">
			<Card>
				<CardHeader>
					<CardTitle>{children ?? t("notFound.title")}</CardTitle>

					<CardContent>{t("notFound.message")}</CardContent>
				</CardHeader>

				<CardFooter className="flex justify-between">
					<Button
						onClick={() => {
							window.history.back();
						}}
					>
						{t("notFound.actions.goBack")}
					</Button>
					<RouterButton variant={"outline"} to="/">
						{t("notFound.actions.startOver")}
					</RouterButton>
				</CardFooter>
			</Card>
		</div>
	);
}
